// src/auth/tokenAccessor.ts
import { userManager } from './AuthManager';

/**
 * Returns the current valid access token, or null if the user is not
 * authenticated or their token has expired.
 *
 * Reads directly from oidc-client-ts on each call — no caching layer
 * means no staleness bugs from forgotten setAccessToken() invocations.
 */
export const getAccessToken = async (): Promise<string | null> => {
	const user = await userManager.getUser();
	if (!user || user.expired) {
		return null;
	}
	return user.access_token;
};
